<div class="h-full w-full flex flex-col items-center justify-start overflow-hidden">
    <div class="w-full space-y-3 p-3 h-full overflow-y-auto scrollbar-transparent">

        <!-- Key Metrics Card -->
        <div class="tto-reporting-card p-4">

            <!-- Header -->
            <div class="flex flex-col gap-y-0.5 mb-4">
                <div class="flex items-center gap-x-1.5">
                    <h3 class="text-sm font-semibold text-foreground">Key metrics</h3>
                    <button type="button"
                        class="text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none"
                        aria-label="Key metrics information">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs text-muted-foreground">Updated in real time.</p>
            </div>

            <!-- Metrics Grid -->
            <div class="grid grid-cols-2 gap-2">
                @for (metric of keyMetrics(); track metric.id) {
                <button type="button"
                    class="col-span-1 flex flex-col gap-y-1 p-3 rounded-xl border border-border bg-card text-left transition-all duration-150 hover:border-primary/40 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1"
                    [attr.aria-pressed]="selectedMetric() === metric.id">
                    <span class="text-xs text-muted-foreground leading-tight">{{ metric.label }}</span>
                    <span class="text-xl font-bold text-foreground leading-tight tabular-nums">{{ metric.value }}</span>
                </button>
                }
            </div>
        </div>
        <!-- Key Metrics Card - END -->

        <!-- Traffic Sources Card -->
        <div class="tto-reporting-card p-4">
            <!-- Header -->
            <div class="flex flex-col gap-y-0.5 mb-4">
                <div class="flex items-center gap-x-1.5">
                    <h3 class="text-sm font-semibold text-foreground">Traffic sources</h3>
                    <button type="button"
                        class="text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none"
                        aria-label="Traffic sources information">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs text-muted-foreground">Where did viewers find this content?</p>
            </div>
            <!-- Header - END -->

            <div class="space-y-3">
                @if (trafficSources().length === 0) {
                    <p class="text-xs text-muted-foreground text-center py-4">No traffic source data available.</p>
                } @else {
                    @for (source of trafficSources(); track source.label) {
                        <div>
                            <div class="flex items-center justify-between mb-1.5">
                                <span class="text-sm text-foreground">{{ source.label }}</span>
                                <span class="text-sm font-semibold text-foreground tabular-nums">{{ source.percentage }}</span>
                            </div>
                            <div class="h-2 w-full rounded-full bg-muted overflow-hidden">
                                <div class="h-full rounded-full traffic-bar"
                                    [style.width]="source.widthPct + '%'">
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
        <!-- Traffic Sources Card - END -->


    </div>
</div>